export const Sort = {
  Popularity: { id: 'POPULARITY', description: 'Popularity', queryName: 'popularity' },
  PriceHigh: { id: 'PRICE_HIGH_LOW', description: 'High - Low Price', queryName: 'price-high' },
  PriceLow: { id: 'PRICE_LOW_HIGH', description: 'Low - High Price', queryName: 'price-low' },
  Newest: { id: 'NEWEST', description: 'Newest', queryName: 'newest' },
};

export const SortOptions = [
  Sort.Popularity,
  Sort.PriceHigh,
  Sort.PriceLow,
  Sort.Newest,
];

export const SORT_ID_TO_QUERY_NAME = {
  [Sort.Popularity.id]: Sort.Popularity.queryName,
  [Sort.PriceHigh.id]: Sort.PriceHigh.queryName,
  [Sort.PriceLow.id]: Sort.PriceLow.queryName,
  [Sort.Newest.id]: Sort.Newest.queryName,
};

export const SORT_QUERY_NAME_TO_ID = {
  [Sort.Popularity.queryName]: Sort.Popularity.id,
  [Sort.PriceHigh.queryName]: Sort.PriceHigh.id,
  [Sort.PriceLow.queryName]: Sort.PriceLow.id,
  [Sort.Newest.queryName]: Sort.Newest.id,
};

export default SortOptions;
